<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="工种名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入工种名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否需要认证" prop="certificate">
                <a-select v-model="queryParam.certificate" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="证书名称" prop="certificateName">
                <a-input v-model="queryParam.certificateName" placeholder="请输入证书名称" allow-clear/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="保险分类" prop="insurance">
                  <a-select v-model="queryParam.insurance" placeholder="请选择" allow-clear>
                    <a-select-option :value="5">一类</a-select-option>
                    <a-select-option :value="6">二类</a-select-option>
                    <a-select-option :value="7">三类</a-select-option>
                    <a-select-option :value="8">四类</a-select-option>
                    <a-select-option :value="9">五类</a-select-option>
                    <a-select-option :value="10">六类</a-select-option>
                    <a-select-option :value="11">S类</a-select-option>
                    <a-select-option :value="1">A类</a-select-option>
                    <a-select-option :value="2">B类</a-select-option>
                    <a-select-option :value="3">C类</a-select-option>
                    <a-select-option :value="4">D类</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否常用工种" prop="regular">
                  <a-select v-model="queryParam.regular" placeholder="请选择" allow-clear>
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否必须买保险" prop="isInsurance">
                  <a-select v-model="queryParam.isInsurance" placeholder="请选择" allow-clear>
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否售后" prop="isAfter">
                  <a-select v-model="queryParam.isAfter" placeholder="请选择" allow-clear>
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="职业代码" prop="jobCode">
                  <a-input v-model="queryParam.jobCode" placeholder="请输入职业代码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="匹配关键词" prop="keywords">
                  <a-input v-model="queryParam.keywords" placeholder="按已配置关键词内容模糊查询" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="创建时间" prop="dateRange">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam.dateRange"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['category:category:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['category:category:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['category:category:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['category:category:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :scroll="{ x: 1500 }"
        :bordered="tableBordered"
      >
        <span slot="certificate" slot-scope="text, record">
          <a-tag v-if="record.certificate === 0" >不需要</a-tag>
          <a-tag v-else-if="record.certificate === 1" color="blue">需要</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-tag v-if="record.type === 0" color="purple">层级</a-tag>
          <a-tag v-else-if="record.type === 1" color="cyan">标签</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 0" color="blue">顶级</a-tag>
          <a-tag v-else-if="record.status === 1" color="green">一级</a-tag>
          <a-tag v-else-if="record.status === 2" color="orange">二级</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="isAfter" slot-scope="text, record">
          <a-tag v-if="record.isAfter === 1" color="green">是</a-tag>
          <a-tag v-else-if="record.isAfter === 0" >否</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="isInsurance" slot-scope="text, record">
          <a-tag v-if="record.isInsurance === 1" color="green">是</a-tag>
          <a-tag v-else-if="record.isInsurance === 0">否</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="regular" slot-scope="text, record">
          <a-tag v-if="record.regular === 1" color="blue">是</a-tag>
          <a-tag v-else-if="record.regular === 0">否</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['category:category:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['category:category:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['category:category:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCategory, delCategory } from '@/api/category/category'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Category',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        jobCode: null,
        certificate: null,
        certificateName: null,
        insurance: null,
        regular: null,
        isInsurance: null,
        isAfter: null,
        keywords: null,
        dateRange: null,
        parentId: null,
        type: 0,
        status: null,
        insuranceMoney: null,
        suretyMoney: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width: 70,
          customRender: (text, record, index) => {
            return index + 1
          }
        },
        {
          title: '工种名称',
          dataIndex: 'name',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '职业代码',
          dataIndex: 'jobCode',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '首字母',
          dataIndex: 'initial',
          width: 80,
          align: 'center'
        },
        {
          title: '是否需要认证',
          dataIndex: 'certificate',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'certificate' }
        },
        {
          title: '证书名称',
          dataIndex: 'certificateName',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发证机构',
          dataIndex: 'issuingAuthority',
          width: 140,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '工种状态',
        //   dataIndex: 'type',
        //   width: 90,
        //   align: 'center',
        //   scopedSlots: { customRender: 'type' }
        // },
        // {
        //   title: '层级',
        //   dataIndex: 'status',
        //   width: 80,
        //   align: 'center',
        //   scopedSlots: { customRender: 'status' }
        // },
        {
          title: '保险费用',
          dataIndex: 'insuranceMoney',
          width: 100,
          align: 'center'
        },
        {
          title: '保证金费用',
          dataIndex: 'suretyMoney',
          width: 110,
          align: 'center'
        },
        {
          title: '是否售后',
          dataIndex: 'isAfter',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'isAfter' }
        },
        {
          title: '是否必须买保险',
          dataIndex: 'isInsurance',
          width: 130,
          align: 'center',
          scopedSlots: { customRender: 'isInsurance' }
        },
        {
          title: '是否常用工种',
          dataIndex: 'regular',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'regular' }
        },
        {
          title: '抽佣比例（%）',
          dataIndex: 'ratio',
          width: 90,
          align: 'center',
          customRender (f) {
            if (f === null || f === undefined || f === '') {
              return '-'
            }
            return Number(f).toFixed(2)
          }
        },
        {
          title: '封顶金额',
          dataIndex: 'maxPrice',
          width: 90,
          align: 'center',
          customRender (f) {
            if (f === null || f === undefined || f === '') {
              return '-'
            }
            return Number(f).toFixed(2)
          }
        },
        {
          title: '佣金冻结天数',
          dataIndex: 'commissionFreezeDays',
          width: 110,
          align: 'center',
          customRender (f) {
            if (f === null || f === undefined || f === '') {
              return '-'
            }
            return f
          }
        },
        {
          title: '匹配关键词',
          dataIndex: 'keywords',
          width: 160,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 140,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询工种列表 */
    getList () {
      this.loading = true
      const params = { ...this.queryParam }
      if (params.dateRange && params.dateRange.length === 2) {
        params.createBeginTime = params.dateRange[0] + ' 00:00:00'
        params.createEndTime = params.dateRange[1] + ' 23:59:59'
      }
      delete params.dateRange
      pageCategory(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        jobCode: undefined,
        certificate: undefined,
        certificateName: undefined,
        insurance: undefined,
        regular: undefined,
        isInsurance: undefined,
        isAfter: undefined,
        keywords: undefined,
        dateRange: undefined,
        parentId: undefined,
        type: 0,
        status: undefined,
        insuranceMoney: undefined,
        suretyMoney: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '将导出工种数据至Excel中',
        onOk () {
          that.download('category/category/export', {
            type: 0
          }, `工种_${new Date().getTime()}.xls`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
